import React from "react";

import { CellProps } from "../../../../../components/dataGrid/dataGrid";

export const formatter = Intl.DateTimeFormat(navigator.language, { dateStyle: 'medium' })

export const DateCell: React.FC<CellProps> = ({ data: { value } }) => {
    if (value === null || value === undefined) {
        return <span />;
    }

    return (
        <span className="cell--date">
            {formatter.format(new Date(value))}
        </span>
    );
}